// extracted by mini-css-extract-plugin
export var FadeIn = "FadeIn-module--FadeIn--kZfrU";
export var fadeIn = "FadeIn-module--fadeIn--2WIWR";